import { ToothSvgComponentProps } from '@/modules/patientList/patientStrip/patientStripOdontogram/types';

const SvgNormal = (props: ToothSvgComponentProps) => (
  <svg
    width={16 * (props.wx ?? 1)}
    height={29 * (props.hx ?? 1)}
    viewBox="0 0 16 29"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={props.className}
  >
    <mask
      id="path-1-outside-1_2050_151"
      maskUnits="userSpaceOnUse"
      x="-0.00012207"
      y="0.324585"
      width="16"
      height="28"
      fill="black"
    >
      <rect fill="white" x="-0.00012207" y="0.324585" width="16" height="28" />
      <path d="M7.99965 1.97609C9.19853 1.97609 12.3163 0.256131 14.117 2.40534C15.5601 4.12776 15.0271 8.26977 13.9927 11.0569C13.6079 12.094 13.5837 13.0808 13.5999 14.1998C13.6756 19.5176 15.1294 26.8221 13.9927 26.8246C12.856 26.8271 10.1402 14.9735 8.00011 14.1998C7.12742 13.8845 4.99988 17.8246 4.49988 20.3246C3.99988 22.8246 3.69175 27.3246 2.99988 27.3246C2.30801 27.3246 2.00707 22.8246 2.00707 21.8246C2.00707 20.8246 2.35686 16.5789 2.30801 14.1998C2.28503 13.0808 2.39182 12.0935 2.00707 11.0569C0.972633 8.26928 0.439637 4.12727 1.88271 2.40534C3.6835 0.256131 6.80077 1.97609 7.99965 1.97609Z" />
    </mask>
    <path
      d="M7.99965 1.97609C9.19853 1.97609 12.3163 0.256131 14.117 2.40534C15.5601 4.12776 15.0271 8.26977 13.9927 11.0569C13.6079 12.094 13.5837 13.0808 13.5999 14.1998C13.6756 19.5176 15.1294 26.8221 13.9927 26.8246C12.856 26.8271 10.1402 14.9735 8.00011 14.1998C7.12742 13.8845 4.99988 17.8246 4.49988 20.3246C3.99988 22.8246 3.69175 27.3246 2.99988 27.3246C2.30801 27.3246 2.00707 22.8246 2.00707 21.8246C2.00707 20.8246 2.35686 16.5789 2.30801 14.1998C2.28503 13.0808 2.39182 12.0935 2.00707 11.0569C0.972633 8.26928 0.439637 4.12727 1.88271 2.40534C3.6835 0.256131 6.80077 1.97609 7.99965 1.97609Z"
      fill={props.fill || '#E4E4E7'}
    />
    <path
      d="M7.99965 1.97609C9.19853 1.97609 12.3163 0.256131 14.117 2.40534C15.5601 4.12776 15.0271 8.26977 13.9927 11.0569C13.6079 12.094 13.5837 13.0808 13.5999 14.1998C13.6756 19.5176 15.1294 26.8221 13.9927 26.8246C12.856 26.8271 10.1402 14.9735 8.00011 14.1998C7.12742 13.8845 4.99988 17.8246 4.49988 20.3246C3.99988 22.8246 3.69175 27.3246 2.99988 27.3246C2.30801 27.3246 2.00707 22.8246 2.00707 21.8246C2.00707 20.8246 2.35686 16.5789 2.30801 14.1998C2.28503 13.0808 2.39182 12.0935 2.00707 11.0569C0.972633 8.26928 0.439637 4.12727 1.88271 2.40534C3.6835 0.256131 6.80077 1.97609 7.99965 1.97609Z"
      stroke={props.stroke || '#A1A1AA'}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      mask="url(#path-1-outside-1_2050_151)"
    />
  </svg>
);
export default SvgNormal;
